import { useCallback } from 'react'
import { trpc } from '@klear/ui/lib/trpc'

export function useOrderEventInvalidate() {
  const utils = trpc.useUtils()

  return useCallback(async (): Promise<void> => {
    await Promise.all([
      utils.orderEvent.listAll.invalidate(),
      utils.documents.list.invalidate(),
      utils.orderEvent.resolveByIdDisplay.invalidate(),
      utils.invoiceOffer.list.invalidate(),
      utils.receivable.list.invalidate(),
      utils.invoice.list.invalidate(),
      utils.invoice.get.invalidate(),
      utils.purchaseOrder.list.invalidate(),
      utils.purchaseOrder.get.invalidate(),
      utils.operational.list.invalidate(),
      utils.operational.get.invalidate(),
      utils.proofOfAcceptance.list.invalidate(),
      utils.proofOfAcceptance.get.invalidate(),
      utils.invoiceOffer.get.invalidate(),
      utils.invoiceOffer.fundReadiness.invalidate(),
      utils.orderEvent.timelineTree.invalidate(),
      utils.orderEvent.listUpdateItems.invalidate(),
      utils.orderEvent.listInternalNotes.invalidate(),
      utils.order.get.invalidate(),
      utils.order.list.invalidate(),
      utils.payable.list.invalidate(),
      utils.payable.get.invalidate(),
      utils.payable.getPaymentByPayableId.invalidate(),
      utils.payable.getPaymentForOrderEvent.invalidate(),
      utils.payable.paymentsForOperationalEvent.invalidate(),
      utils.fee.invalidate(),
      utils.collection.invalidate(),
      utils.disbursement.listDisbursementPayments.invalidate(),
      utils.disbursement.listDisbursables.invalidate(),
      utils.disbursement.listDisbursableAdvances.invalidate()
    ])
  }, [utils])
}
